export const SESSION_EXPIRED_EVENT = 'etv-session-expired';

let sessionExpiryNotified = false;

const getErrorText = (data) => {
  if(!data) return '';
  if(typeof data === 'string') return data;
  return [data.error, data.message, data.error_message, data.reason]
    .filter(Boolean)
    .join(' ');
};

export function isAuthenticationFailure(response, data) {
  if(response?.status === 401) return true;
  if(data?.result === true || data?.success === true) return false;
  const errorText = getErrorText(data);
  return /invalid[\s_-]*(?:access[\s_-]*)?token|expired[\s_-]*(?:access[\s_-]*)?token|session[\s_-]*expired|authentication[\s_-]*(?:failed|required)|(?:not|non)[\s_-]*authenticated|unauthori[sz]ed|login[\s_-]*required|access_token missing in header/i.test(errorText);
}

export function notifySessionExpired() {
  if(sessionExpiryNotified) return;
  sessionExpiryNotified = true;
  localStorage.removeItem('etv.access_token');
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
}

export function handleAuthenticationFailure(response, data) {
  if(!isAuthenticationFailure(response, data)) return false;
  notifySessionExpired();
  return true;
}

export function resetSessionExpiryNotification() {
  sessionExpiryNotified = false;
}
